import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import { useModalStore } from '@features/modal'

import Button from '@shared/ui/button'

import styles from './styles.module.scss'

export default function VerifierModal ({
  success = false,
}: {
  success?: boolean;
}) {
  const { t } = useTranslation('personal')
  const { closeModal } = useModalStore()
  return (
    <div className={styles.modal}>
      <ReactSVG
        className={styles.modal__icon}
        src={`/icons/${success ? 'check' : 'close'}_circle.svg`}
        wrapper="span"
      />
      <h3 className={styles.modal__title}>
        {success
          ? t('payment.modal-title-success')
          : t('payment.modal-title-reject')}
      </h3>
      <p className={styles.modal__description}>
        {success
          ? t('payment.modal-desc-success')
          : t('payment.modal-desc-reject')}
      </p>
      <Button
        onClick={() => closeModal('verifierPayment')}
        className={styles.modal__button}
        size="large"
      >
        {t('payment.modal-button')}
      </Button>
    </div>
  )
}
